import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GoogleAdUnit from '../../components/GoogleAdUnit';

const SidebarAds = ({ page }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isVisible1, setIsVisible1] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        setIsVisible(false);
        setIsVisible1(false);

        const timeout = setTimeout(() => {
            setIsVisible(true);
            setIsVisible1(true);
        }, 500);

        return () => clearTimeout(timeout);
    }, [page]);

    return (
        <>
            <div className='AdwrapperwithText'>
                <div
                    className={`ad-wrapper ${isVisible ? '' : 'hidden'}`}
                    key={`ad-slot-2-${page}`}
                    style={{ width: '100%', height: '250px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <GoogleAdUnit
                        key={`sidebar-ad-1-${page}`}
                        adSlot="6996169711"
                        fullWidthResponsive={false}
                        style={{ display: 'inline-block', width: '100%', height: '250px' }}
                    />
                </div>
                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
            </div>
            <div className='AdwrapperwithText'>
                <div
                    className={`ad-wrapper ${isVisible1 ? '' : 'hidden'}`}
                    key={`ad-slot-1-${page}`}
                    style={{ width: '100%', height: '250px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <GoogleAdUnit
                        key={`sidebar-ad-2-${page}`}
                        adSlot="9925315884"
                        fullWidthResponsive={false}
                        style={{ display: 'inline-block', width: '100%', height: '250px' }}
                    />
                </div>
                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
            </div>
        </>
    );
};

export default SidebarAds;
